module.exports = __webpack_public_path__ + "static/media/job-guarantee-background-v2-mobile.9ed4fd77.png";